export default __webpack_public_path__ + "assets/schick_banner_740x120-70b30232a1c61a2a7efbcac36ed9139a.jpg";